"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IRdfaPattern.js.map